import { createContext } from 'react'

import type { OnboardingInterpreter } from './machine'
export const OnboardingContext = createContext({} as OnboardingInterpreter)
